// #region Imports

import Vue from 'vue';
// io.account Page-Components
import './account-pages';

// #endregion

// #region Component Registration

Vue.component('IoAccountRegisterForm', () => import(/* webpackChunkName: "account-components" */ '@/account/components/IoAccountRegisterForm.vue'));
Vue.component('IoAccountRegisterSuccess', () => import(/* webpackChunkName: "account-components" */ '@/account/components/IoAccountRegisterSuccess.vue'));

// #endregion
